export default __webpack_public_path__ + "static/media/ownerrez_step2.1bfa4bef.jpg";